export default function System() {
  return (
    <div className="p-3">
      <div className="p-3 vh-100 bg-white rounded" />
    </div>
  );
}
